import type {UsuarioColaboradorVm} from "@/domain/type/usuario.type";

export interface AutorizacaoAcaoVm {

    autorizacaoId: string
    tipoAutorizacao: EAutorizacaoAcaoTipo
    tipoAutorizacaoDescricao: string
    statusAutorizacao: EAutorizacaoAcaoStatus
    statusAutorizacaoDescricao: string
    codigoAutorizacao: string
    observacao: string

    criadoEm: Date
    criadoEmFormatado: string

    dataUtilizacao?: Date
    dataUtilizacaoFormatado?: string

    colaborador: UsuarioColaboradorVm
    colaboradorUtilizacao?: UsuarioColaboradorVm

}

export enum EAutorizacaoAcaoTipo {
    DescontoNoProduto = 1,
    CancelamentoVenda = 2,
    CancelamentoSeguro = 3
}

export enum EAutorizacaoAcaoStatus {
    Ativo = 1,
    Expirado = 2,
    Cancelado = 3,
    Utilizado = 4
}

export function dataAsAutorizacaoAcaoVm(data: any): AutorizacaoAcaoVm {
    return data as AutorizacaoAcaoVm;
}

export interface InfoAutorizacaoDesconto {
    porcentagemDesconto: number,
    grupoPlanoSeguroId: number
}

export interface ResultadoCodigoAutorizacao {
    mensagem: string,
    tipoAutorizacao: EAutorizacaoAcaoTipo,
    resultado: boolean,
    valorDescontoMaximo: number
    codigoAutorizacao: string
}